import type { DropdownItem } from '@components/Dropdown';

export const animationList: (DropdownItem<number> & {
  animationName: string;
  duration?: number;
})[] = [
  { id: 0, name: '无', animationName: '' },
  { id: 1, name: '左右摇摆', animationName: 'shake-bottom' },
  { id: 2, name: '中心摇摆', animationName: 'shake-center' },
  { id: 3, name: '中心旋转', animationName: 'rotate-center' },
  { id: 4, name: '中心缩放', animationName: 'pulse-zoomin' },
  { id: 5, name: '垂直翻转', animationName: 'flip-vertical' },
  { id: 6, name: '水平翻转', animationName: 'flip-horizontal' },
  { id: 7, name: '闪烁', animationName: 'blink-2' },
  { id: 8, name: '抖动', animationName: 'rubberband-horizontal' },
];

export const animationEnterList: (DropdownItem<number> & {
  animationName: string;
  duration?: number;
})[] = [
  { id: 0, name: '无', animationName: '' },
  { id: 1, name: '淡入', animationName: 'fade-in', duration: 1.2 },
  { id: 2, name: '放大淡入', animationName: 'fade-in-fwd', duration: 0.6 },
  { id: 3, name: '缩小淡入', animationName: 'fade-in-bck', duration: 0.6 },
  {
    id: 4,
    name: '中心放大进入',
    animationName: 'scale-in-center',
    duration: 0.5,
  },
  {
    id: 5,
    name: '水平展开',
    animationName: 'scale-in-hor-center',
    duration: 0.5,
  },
  {
    id: 6,
    name: '垂直展开',
    animationName: 'scale-in-ver-center',
    duration: 0.5,
  },
  { id: 7, name: '向下展开', animationName: 'scale-in-ver-top', duration: 0.5 },
  {
    id: 8,
    name: '向上展开',
    animationName: 'scale-in-ver-bottom',
    duration: 0.5,
  },
  {
    id: 10,
    name: '向右展开',
    animationName: 'scale-in-hor-left',
    duration: 0.5,
  },
  {
    id: 9,
    name: '向左展开',
    animationName: 'scale-in-hor-right',
    duration: 0.5,
  },
  {
    id: 22,
    name: '向上滑动进入',
    animationName: 'swipe-up-to-enter',
    duration: 0.5,
  },
  {
    id: 23,
    name: '向下滑动进入',
    animationName: 'swipe-down-to-enter',
    duration: 0.5,
  },
  {
    id: 25,
    name: '向右滑动进入',
    animationName: 'swipe-right-to-enter',
    duration: 0.5,
  },
  {
    id: 24,
    name: '向左滑动进入',
    animationName: 'swipe-left-to-enter',
    duration: 0.5,
  },
  {
    id: 11,
    name: '中心旋转进入',
    animationName: 'rotate-in-center',
    duration: 0.6,
  },
  {
    id: 12,
    name: '向右旋转进入',
    animationName: 'rotate-in-2-cw',
    duration: 0.5,
  },
  {
    id: 13,
    name: '向左旋转进入',
    animationName: 'rotate-in-2-ccw',
    duration: 0.5,
  },
  {
    id: 14,
    name: '底部翻转进入',
    animationName: 'flip-in-hor-bottom',
    duration: 0.5,
  },
  {
    id: 15,
    name: '顶部翻转进入',
    animationName: 'flip-in-hor-top',
    duration: 0.5,
  },
  {
    id: 16,
    name: '右侧翻转进入',
    animationName: 'flip-in-ver-right',
    duration: 0.5,
  },
  {
    id: 17,
    name: '左侧翻转进入',
    animationName: 'flip-in-ver-left',
    duration: 0.5,
  },
  {
    id: 18,
    name: '底部上滑进入',
    animationName: 'slide-in-bottom',
    duration: 0.5,
  },
  {
    id: 19,
    name: '顶部下滑进入',
    animationName: 'slide-in-top',
    duration: 0.5,
  },
  {
    id: 20,
    name: '左侧右滑进入',
    animationName: 'slide-in-left',
    duration: 0.5,
  },
  {
    id: 21,
    name: '右侧左滑进入',
    animationName: 'slide-in-right',
    duration: 0.5,
  },
];

export const animationExitList: (DropdownItem<number> & {
  animationName: string;
  duration?: number;
})[] = [
  { id: 0, name: '无', animationName: '' },
  { id: 1, name: '淡出', animationName: 'fade-out', duration: 1 },
  { id: 2, name: '放大淡出', animationName: 'fade-out-fwd', duration: 0.7 },
  { id: 3, name: '缩小淡出', animationName: 'fade-out-bck', duration: 0.7 },
  {
    id: 4,
    name: '中心缩小退出',
    animationName: 'scale-out-center',
    duration: 0.5,
  },
  {
    id: 5,
    name: '水平收起',
    animationName: 'scale-out-horizontal',
    duration: 0.5,
  },
  {
    id: 6,
    name: '垂直收起',
    animationName: 'scale-out-vertical',
    duration: 0.5,
  },
  {
    id: 7,
    name: '向下收起',
    animationName: 'scale-out-ver-bottom',
    duration: 0.5,
  },
  {
    id: 8,
    name: '向上收起',
    animationName: 'scale-out-ver-top',
    duration: 0.5,
  },
  {
    id: 9,
    name: '向右收起',
    animationName: 'scale-out-hor-right',
    duration: 0.5,
  },
  {
    id: 10,
    name: '向左收起',
    animationName: 'scale-out-hor-left',
    duration: 0.5,
  },
  {
    id: 23,
    name: '向下滑动退出',
    animationName: 'swipe-down-to-exit',
    duration: 0.5,
  },
  {
    id: 22,
    name: '向上滑动退出',
    animationName: 'swipe-up-to-exit',
    duration: 0.5,
  },
  {
    id: 25,
    name: '向右滑动退出',
    animationName: 'swipe-right-to-exit',
    duration: 0.5,
  },
  {
    id: 24,
    name: '向左滑动退出',
    animationName: 'swipe-left-to-exit',
    duration: 0.5,
  },
  {
    id: 11,
    name: '中心旋转退出',
    animationName: 'rotate-out-center',
    duration: 0.6,
  },
  {
    id: 12,
    name: '向右旋转退出',
    animationName: 'rotate-out-2-cw',
    duration: 0.6,
  },
  {
    id: 13,
    name: '向左旋转退出',
    animationName: 'rotate-out-2-ccw',
    duration: 0.6,
  },
  {
    id: 14,
    name: '底部翻转退出',
    animationName: 'flip-out-hor-bottom',
    duration: 0.5,
  },
  {
    id: 15,
    name: '顶部翻转退出',
    animationName: 'flip-out-hor-top',
    duration: 0.5,
  },
  {
    id: 16,
    name: '右侧翻转退出',
    animationName: 'flip-out-ver-right',
    duration: 0.5,
  },
  {
    id: 17,
    name: '左侧翻转退出',
    animationName: 'flip-out-ver-left',
    duration: 0.5,
  },
  {
    id: 18,
    name: '上滑顶部退出',
    animationName: 'slide-out-top',
    duration: 0.5,
  },
  {
    id: 19,
    name: '下滑底部退出',
    animationName: 'slide-out-bottom',
    duration: 0.5,
  },
  {
    id: 20,
    name: '右滑退出',
    animationName: 'slide-out-right',
    duration: 0.5,
  },
  {
    id: 21,
    name: '左滑退出',
    animationName: 'slide-out-left',
    duration: 0.5,
  },
];
